module.exports = __webpack_public_path__ + "static/media/planet.5e10af9f.png";